import React, { Component } from 'react';
import { Modal, Radio, Input, Spin, message } from 'antd';
import Fetch from '../../../common/Fetch';
import API_URL from '../../../common/url';
import Text from '../../basicElement/Text';

const { Group: RadioGroup } = Radio;

class ApproveCancelApply extends Component {
    state = {
        data: {},
        record: {},
        visible: false,
        loading: false,
    }

    loadData = () => {
        this.setState({ loading: true });
        Fetch.post(API_URL.notice.queryJdeNoticeCancelById, { jdeNoticeCancelId: this.relateId })
        .then(res => {
            this.setState({
                record: res.data || {},
                loading: false,
            });
        }).catch(error => {
            console.error(error);
            this.setState({ loading: false });
        });
    }

    show = (relateId) => {
        this.relateId = relateId;
        this.setState({ visible: true }, () => {
            this.loadData();
        });
    }

    hide = () => {
        this.setState({
            data: {},
            record: {},
            visible: false,
        });
    }

    handleChange = (value, key) => {
        const { data } = this.state;
        switch(key) {
            case 'status':
                data.reason = undefined;
            default:
                data[key] = value;
        }
        this.setState({ data });
    }

    submit = () => {
        const { data } = this.state;
        const { status, reason } = data;
        if (!status) {
            message.warning('请选择审批意见！');
            return;
        } else if (status === 'REJECT' && !reason) {
            message.warning('请输入拒绝原因！');
            return;
        }

        this.setState({ loading: true });
        Fetch.post(API_URL.notice.handleCancelNotice, {
            ...data,
            jdeNoticeCancelId: this.relateId,
        })
        .then(res => {
            message.success(res.success);
            this.setState({
                loading: false,
            }, () => {
                this.hide();
                this.props.loadData();
            });
        }).catch(error => {
            console.error(error);
            this.setState({ loading: false });
        });
    }

    getContent = () => {
        const { record, data } = this.state;
        const {
            investigationName,
            investigationJdeContractCode,
            reason: cancelReason,
        } = record;
        const { status, reason } = data;
        return (
            <ul className="modal-list">
                <li className="modal-item">
                    <div className="item-left">项目简称:</div>
                    <div className="item-right">{investigationName}</div>
                </li>
                <li className="modal-item">
                    <div className="item-left">JDE项目号:</div>
                    <div className="item-right">{investigationJdeContractCode}</div>
                </li>
                <li className="modal-item">
                    <div className="item-left">申请原因:</div>
                    <div className="item-right">{cancelReason}</div>
                </li>
                <li className="modal-item" style={{ borderTop: '1px solid #f1f1f1' }}>
                    <div className="item-left"><Text asterisk={true} colon={true}>审批意见</Text></div>
                    <div className="item-right">
                        <RadioGroup onChange={e => this.handleChange(e.target.value, 'status')} value={status}>
                            <Radio value='AGREE'>同意</Radio>
                            <Radio value='REJECT'>拒绝</Radio>
                        </RadioGroup>
                    </div>
                </li>
                {
                    status === 'REJECT' &&
                    <li className="modal-item">
                        <div className="item-left">&nbsp;</div>
                        <div className="item-right">
                            <Input
                                maxLength="255"
                                value={reason}
                                placeholder="请填写拒绝原因"
                                style={{width: 240}}
                                onChange={e => this.handleChange(e.target.value, 'reason')}
                            />
                        </div>
                    </li>
                }
            </ul>
        );
    }

    render() {
        const { visible, loading } = this.state;
        return (
            <Modal
                title="审批消息通知取消申请"
                visible={visible}
                onCancel={this.hide}
                onOk={this.submit}
                confirmLoading={loading}
                maskClosable={false}
                width="520px"
            >
                <Spin spinning={loading}>
                    <div className="modal-content" style={{ padding: 0 }}>
                        {this.getContent()}
                    </div>
                </Spin>
            </Modal>
        );
    }
}

export default ApproveCancelApply;


// WEBPACK FOOTER //
// ./src/components/layout/notice/ApproveCancelApply.js